import { useCurrentAddressInfo } from '@/hooks';
import { useMutation, useQuery } from 'react-query';
import { getSignText } from '../../hooks';
import { request, toastError } from '@/utils';

export const useSuicideText = ({ enabled }: { enabled?: boolean }) => {
  const url = '/user/signature';
  const { address } = useCurrentAddressInfo();
  return useQuery([url, address], () => getSignText('suicide'), {
    enabled: !!address && enabled,
  });
};

export const useGetSuicideText = () => {
  return useMutation(() => getSignText('suicide'), {
    onError(err) {
      toastError(err);
    },
  });
};

export const useSuicide = () => {
  return useMutation((signature: string) =>
    request.post<{ is_success: boolean }>('/user/suicide', { signature }),
  );
};
